import { useState, useSyncExternalStore } from "react";
import { chooseMetaConsent, getMetaState, subscribeMeta } from "./meta";
import { t } from "../locale";

export default function MarketingConsent() {
  const { configuration, consent, error } = useSyncExternalStore(subscribeMeta, getMetaState);
  const [expanded, setExpanded] = useState(false), [saving, setSaving] = useState(false);
  if (!configuration?.enabled) return null;
  async function choose(granted: boolean) { setSaving(true); await chooseMetaConsent(granted); setSaving(false); setExpanded(false); }
  return <section className="marketing-choice" aria-label={t("Advertising measurement")}>
    {consent.granted === null || expanded ? <>
      <strong>{t("Advertising measurement")}</strong>
      <p>{t("Allow us to share page visits, Home Screen actions and playback events with Meta, including browser information and advertising identifiers, to measure our ads? You can watch without accepting and change this choice here at any time.")}</p>
      <div><button className="secondary-button" disabled={saving} onClick={() => void choose(false)}>{t("Do not allow")}</button><button className="secondary-button" disabled={saving} onClick={() => void choose(true)}>{t("Allow measurement")}</button></div>
    </> : <button className="text-button" onClick={() => setExpanded(true)}>{t("Advertising settings")} · {consent.granted ? t("Allowed") : t("Not allowed")}</button>}
    {error && <p role="status">{error}</p>}
  </section>;
}
